import { validateExpirationInFuture } from "cc-tools/expiration-validator";

export const isFutureExpiration = () => (value: string) => {
  return validateExpirationInFuture(value);
};
